import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  CircularProgress,
  type CircularProgressProps,
} from '@mui/material'

export type LoadingIndicatorProps = Pick<
  CircularProgressProps,
  /**
   * @default 'indeterminate'
   */
  | 'variant'
  | 'value'
  | 'sx'

  /**
   * @default 16
   */
  | 'size'

  /**
   * @default 'primary'
   */
  | 'color'
>

export const LoadingIndicator = ({
  sx,
  color = 'primary',
  size = 16,
  variant = 'indeterminate',
}: LoadingIndicatorProps) => (
  <CircularProgress color={color} size={size} variant={variant} data-chromatic="ignore" aria-label="loading" sx={sx} />
)
